import {
    IosDependenciesDependencyReport,
    IosDependenciesReport,
    IosDependenciesVersionConstraint,
} from '@/types/iosDependencies';

export const STATUS_LABELS: Record<string, string> = {
    'up-to-date': 'Up to date',
    'update-available': 'Update available',
    'not-checked': 'Not checked',
    'no-current-version': 'No current version',
    'update-check-skipped': 'Update check skipped',
};

export const STATUS_COLORS: Record<string, string> = {
    'up-to-date': 'green',
    'update-available': 'blue',
    'not-checked': 'default',
    'no-current-version': 'default',
    'update-check-skipped': 'default',
};

export const formatStatusLabel = (status: string): string => STATUS_LABELS[status] ?? status;
export const statusTagColor = (status: string): string => STATUS_COLORS[status] ?? 'default';

export const formatMinIOS = (value?: string): string => (value ? `iOS ${value}` : '—');

export const formatConstraint = (constraint?: IosDependenciesVersionConstraint): string => {
    if (!constraint) {
        return '';
    }
    switch (constraint.kind) {
        case 'exact':
            return `exact(${constraint.minVersion ?? ''})`;
        case 'upToNextMajor':
        case 'upToNextMinor':
            return `${constraint.kind}(${constraint.minVersion ?? ''})`;
        case 'range':
            return `range(${constraint.minVersion ?? ''}..<${constraint.maxVersion ?? ''})`;
        case 'branch':
            return `branch(${constraint.branch ?? ''})`;
        case 'revision': {
            const rev = constraint.revision ?? '';
            return `revision(${rev.length > 12 ? rev.slice(0, 12) : rev})`;
        }
        default:
            return constraint.kind;
    }
};

export const truncatedRevision = (revision?: string): string => {
    if (!revision) {
        return '';
    }
    return revision.length > 12 ? `${revision.slice(0, 12)}…` : revision;
};

export const directnessLabel = (graph?: string[]): { label: string; chain?: string } => {
    if (!graph || graph.length === 0) {
        return { label: 'Direct' };
    }
    if (graph.length === 1 && graph[0] === 'unknown') {
        return { label: 'Indirect (parent unknown)' };
    }
    return { label: 'Indirect', chain: graph.join(' → ') };
};

export const isIndirect = (row: IosDependenciesDependencyReport): boolean =>
    !!(row.dependencyGraph && row.dependencyGraph.length > 0);

export const getAvailableUpdates = (report?: IosDependenciesReport): IosDependenciesDependencyReport[] =>
    report?.dependencies?.filter((dep) => dep.status === 'update-available') ?? [];

export const countUpdates = (report?: IosDependenciesReport): number => getAvailableUpdates(report).length;

export const totalDeps = (report?: IosDependenciesReport): number => report?.dependencies?.length ?? 0;
